import React from 'react';
import { FiArrowLeft } from "react-icons/fi";

const stepThree = ({ password, setPassword, confirmPassword, setConfirmPassword, submitError, setStep, handleSubmitPassword, submitPassLoading }: any) => {
  return (
    <form>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-3">
        <div>
          <label className="zs-label zs-label-required">Create Password</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onKeyDown={(e) => e.key === " " && e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            onChange={(e) => setPassword(e.target.value)}
            className="zs-input h-11"
          />
        </div>
        <div>
          <label className="zs-label zs-label-required">Confirm Password</label>
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onKeyDown={(e) => e.key === " " && e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="zs-input h-11"
          />
        </div>
      </div>
      <p className="zs-hint">Use at least 6 characters.</p>
      {submitError && <p className="zs-error">{submitError}</p>}
      <div className="mt-6 flex items-center justify-between gap-3">
        <button onClick={() => setStep(2)} type="button" className="zs-btn zs-btn-ghost">
          <FiArrowLeft aria-hidden="true" />
          Back
        </button>
        <button
          type="submit"
          className="zs-btn zs-btn-primary min-w-[120px]"
          onClick={handleSubmitPassword}
          disabled={submitPassLoading}
        >{submitPassLoading ? 'Claim...' : 'Claim'}</button>
      </div>
    </form>
  );
};

export default stepThree;
